import { createFileRoute } from '@tanstack/react-router'
import OnboardingLayout from '@/pages/auth/onboarding/onboarding-layout'
import { QuickSetupForm } from '@/pages/auth/onboarding/components/quick-setup-form'
import { useOnboardingTracking } from '@/hooks/use-onboarding-tracking'

export const Route = createFileRoute('/(auth)/onboarding/quick-setup')({
  component: QuickSetupPage,
})

function QuickSetupPage() {
  const { track } = useOnboardingTracking()

  return (
    <OnboardingLayout currentStep={3} totalSteps={7}>
      <QuickSetupForm onAnalytics={track} />
    </OnboardingLayout>
  )
}